// import components
import { styled } from '@mui/material';
import Tile from './Tile';

export const StyledTile = styled(Tile)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius
}));
